




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { InvoiceModelType } from '@/modules/invoice/models/invoice-reource.model'

@Component
export default class InvoiceModelTypeView extends Vue {
  @Prop({ required: true }) type!: InvoiceModelType
  @Prop({ required: true }) types!: { [key in InvoiceModelType]: string }
  @Prop({ default: false }) dark: boolean

  get typeColor() {
    switch (this.type) {
      case InvoiceModelType.CUSTOM:
        return 'text-green'
      case InvoiceModelType.MANUAL:
        return this.dark ? 'text-yellow' : 'text-amber-7'
      case InvoiceModelType.CONTENT_CAMPAIGN:
        return 'text-tes-navy-blue-darker'
      default:
        return ''
    }
  }
}
